import React from 'react';
import {
	EntryKeys,
	ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT,
} from '@atlassian/jira-feedback-collector/src/constants.tsx';
import { FeedbackCollectorButton } from '@atlassian/jira-feedback-collector/src/ui/button/index.tsx';

export const FEEDBACK_COLLECTOR_LOCATION = 'project-pages.project-directories.versions';

export const FeedbackButton = (): React.JSX.Element => {
	const feedbackContextEntries = [
		{ id: EntryKeys.FEEDBACK_COLLECTOR_LOCATION, value: FEEDBACK_COLLECTOR_LOCATION },
	];

	return (
		<FeedbackCollectorButton
			entrypointId={ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT}
			feedbackContext={feedbackContextEntries}
		/>
	);
};
